import fr from "@/locales/fr.json";
import pt from "@/locales/pt.json";
import es from "@/locales/es.json";

export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
  { code: "pt", label: "Português" },
  { code: "es", label: "Español" },
];
const DICTS = { fr, pt, es };
const KEY = "ml_lang";

const initial = () => {
  const saved = localStorage.getItem(KEY);
  if (saved && LANGUAGES.some((l) => l.code === saved)) return saved;
  const nav = (navigator.language || "en").slice(0, 2);
  return DICTS[nav] ? nav : "en";
};

let current = initial();
const listeners = new Set();

export const getLang = () => current;
export function setLang(code) {
  current = code;
  localStorage.setItem(KEY, code);
  document.documentElement.lang = code;
  listeners.forEach((fn) => fn(code));
}
export const subscribeLang = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };

export function t(text, vars) {
  let s = (current !== "en" && DICTS[current]?.[text]) || text;
  if (vars) Object.entries(vars).forEach(([k, v]) => { s = s.replaceAll(`{${k}}`, v); });
  return s;
}
